import { useState } from "react";

const Terminal = () => {
    const [history, setHistory] = useState([]);
    const [input, setInput] = useState([]);
    const fetchProjects = async () => {
        try {
            const res = await fetch("https://api.github.com/users/Rafita261/repos");
            const data = await res.json();
            const sorted = data
                .sort((a, b) => new Date(b.pushed_at) - new Date(a.pushed_at))
                .slice(0, 5);
            const repos = sorted.map(repo => `- ${repo.name} : ${repo.description || "Pas de description"}`);
            return repos;
        } catch (error) {
            return "Erreur de connexion";
        }
    };

    const handleCommand = async (e) => {
        if (e.key === "Enter") {
            const cmd = input.toLowerCase().trim();
            let output;

            switch (cmd) {
                case 'help':
                    output = ["Commandes : about, projects, contact, clear, ls, gui-portfolio"];
                    break;
                case 'about':
                    output = [
                        "Je suis Fitahiana Christalin RATSIMBAZAFY, développeur backend,",
                        "étudiant en L2 à l'École Nationale d'Informatique Fianarantsoa.",
                        "Passionné de l'innovation technologique, de la cybersécurité et de l'IA..."
                    ];
                    break;
                case 'contact':
                    output = [
                        "E-mail : ratsimbazafyf.christalin@gmail.com",
                        "Tel : +261 38 49 055 96",
                        "Github : https://github.com/Rafita261/"
                    ];
                    break;
                case "clear":
                    setHistory([]);
                    setInput('');
                    return;
                case "projects":
                    output = await fetchProjects(); // doit déjà être un tableau
                    break;
                case "ls":
                    output = ["about", "projects", "contact", "help", "clear", "gui-portfolio"];
                    break;
                case "gui-portfolio":
                    output = "";
                    window.location = "https://rafita261.github.io/Chriskely"; break
                default:
                    output = ["Commande inconnue"];
            }

            setHistory(prev => [...prev, `(chriskely@portfolio)$ ${cmd}`, ...output]);
            setInput("");
        }
    };

    const getLineStyle = (line) => {
        if (line.includes("Commande inconnue")) {
            return { color: "red" }; // Erreurs
        }
        return {}; // Par défaut, pas de couleur
    };

    return (
        <div className="fullscreen-terminal bg-black text-green-400 font-mono p-4 h-screen overflow-y-auto">
            <div>Salut Salut ... Bienvenue dans mon portfolio, help pour aide</div>
            {history.map((line, i) => (
                <div key={i} style={getLineStyle(line)}>{line}</div>
            ))}
            <span>(chriskely@portfolio)$ </span>
            <input
                className="terminal-input"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleCommand}
                autoFocus
            />
        </div>
    );
};

export default Terminal;